exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-other-region-tsx": () => import("./../../../src/pages/other-region.tsx" /* webpackChunkName: "component---src-pages-other-region-tsx" */)
}

